module.exports = __webpack_public_path__ + "img/logo.0f4af4a9.png";